import { MatDialog } from '@angular/material/dialog';
import { Injector } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BusService } from './bus.service';
import { DriverScheduleService } from './driverschedule.service';
import { BfsService } from './bfs.service';


export class ServiceLocator {
  static injector: Injector;
  static dialog: MatDialog;
  static driverScheduleService: DriverScheduleService;
  static toastr: ToastrService;
  static busService: BusService;
  static bfsService: BfsService
}
